import { INFO, PRIMARY, SECONDARY } from 'theme/palette'

const buttonStyles = {
  background: '#A2C1C2',
  borderRadius: '8px'
}

const overrideCurrencyStyle = {
  border: '1px solid',
  borderRadius: '8px'
}

const commonNoActionButtonStyle = {
  background: '#A2C1C2',
  borderRadius: '8px',
  color: '#000000',
  padding: '11px 22px',
  boxShadow: 'none',
  border: 'none',
  ':hover': {
    bgcolor: PRIMARY.main,
    boxShadow: 'none'
  }
}

const commonProceedButtonStyle = {
  background: SECONDARY.buttons,
  borderRadius: '8px',
  padding: '11px 22px',
  color: '#FFFF',
  boxShadow: 'none',
  border: 'none',
  ':hover': {
    bgcolor: PRIMARY.main,
    boxShadow: 'none'
  }
}

const commonBtnStyles = {
  backgroundColor: SECONDARY.buttons,
  color: 'white',
  fontSize: '14px',
  fontWeight: 700,
  border: 'none',
  padding: '10px 14px',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: INFO.dark,
    border: 'none',
    boxShadow: 'none'
  }
}
export { buttonStyles, overrideCurrencyStyle, commonNoActionButtonStyle, commonProceedButtonStyle, commonBtnStyles }
